import { TTP_API_URL } from "Config";

export const getDatesBetweenDates = (startDate, endDate) => {
  let dates = [];
  //to avoid modifying the original date
  const theDate = new Date(startDate);
  while (theDate < endDate) {
    dates = [...dates, new Date(theDate)];
    theDate.setDate(theDate.getDate() + 1);
  }
  dates = [...dates, endDate];
  return dates;
};

export const getCountOpenDays = dates => {
  let countOpenDays = 0;
  dates.forEach(date => {
    if (![0, 6].includes(date.getDay())) {
      countOpenDays++;
    }
  });
  return countOpenDays;
};

export const isEqualDates = (d, date) => {
  return (
    d.getMonth() === date.getMonth() &&
    d.getDate() === date.getDate() &&
    d.getFullYear() === date.getFullYear()
  );
};

export const filterDates = (baseDates, dates) => {
  return baseDates.filter(date => !dates.find(d => isEqualDates(d, date)));
};

export const filterDatesTags = (monthTags, dates) => {
  return monthTags.filter(tag => !dates.find(d => isEqualDates(d, tag.date)));
};

export const filterDatesTagsByOptions = (planning, month, dates, options) => {
  options.forEach(option => {
    planning[option][month] = planning[option][month].filter(
      tag => !dates.find(d => isEqualDates(d, tag.date))
    );
  });
  return planning;
};

export const filterCollaboratorDatesTagsByOptions = (
  planning,
  month,
  dates,
  options
) => {
  options.forEach(option => {
    planning[option][month] = planning[option][month]
      ? planning[option][month].filter(
          tag => !dates.find(d => isEqualDates(d, tag.date))
        )
      : [];
  });
  return planning;
};

export const mapAndSortCalendarPlanningByMonth = (planning, month, options) => {
  let dates = [];
  options.forEach(option => {
    planning[option][month] &&
      planning[option][month].forEach(date => {
        dates.push({ ...date, option: option });
      });
  });

  dates.sort(
    (a, b) =>
      a.date.getDate() > b.date.getDate()
        ? 1
        : b.date.getDate() > a.date.getDate()
          ? -1
          : 0
  );

  // map for tags
  const result = [];
  for (const item of dates) {
    if (!result[item.key]) result[item.key] = [];
    result[item.key].push(item);
  }

  return Object.values(result);
};

export const prepareCollaboratorAbsencesForSave = (
  planning,
  month,
  monthNumber,
  options
) => {
  const step1 = [];
  options.forEach(option => {
    planning[option][month] &&
      planning[option][month].forEach(item => {
        if (!step1[item.key]) step1[item.key] = [];
        step1[item.key].push(item);
      });
  });

  let step2 = Object.values(step1);
  let result = [];
  step2.forEach(absence => {
    let from = absence[0].date;
    let to = absence[absence.length - 1].date;
    let object = {
      id: absence[0]["id"],
      from:
        from.getFullYear() + "-" + (from.getMonth() + 1) + "-" + from.getDate(),
      to: to.getFullYear() + "-" + (to.getMonth() + 1) + "-" + to.getDate(),
      reason: absence[0].label,
      rejectReason:
        absence[0]["vacationStatus"] === "REJECTED"
          ? absence[0].rejectReason
          : "",
      type: absence[0].type,
      backup: absence[0].backup,
      month: month,
      attachments: absence[0].attachments,
      numberDays: absence.length,
      numberHours: absence[0].hours,
      listOfDays: absence.map(dates => {
        return dates.date;
      })
    };

    if (absence[0]["vacationStatus"] !== undefined) {
      object["vacationStatus"] = absence[0]["vacationStatus"];
    }

    result.push(object);
  });

  return result;
};

export const getTemporaryAnnexeFileLink = (id, filePath, token) => {
  let url = `${TTP_API_URL}/data/annexe/file?access_token=${token}&id=${id}&filePath=${encodeURIComponent(
    filePath
  )}`;

  return url;
};



// WEBPACK FOOTER //
// ./src/utils/calendar.js